import { Box, BoxProps, ColorOptions } from '@jfs/ui-new'
import { TextInputWithCb } from '../../components/TextInputWithCb'
import { convertCamelCaseToString } from '../../utils'

const getView = (data: any) => {
  if (!data) {
    return null
  }

  return Object.keys(data).map(function (key) {
    return (
      <Box paddingVertical={8} marginRight={16} f={1}>
        <TextInputWithCb label={convertCamelCaseToString(key)} value={data[key] ?? ''} showCheckbox={false} />
      </Box>
    )
  })
}

export const Details = ({ data, hide = false }: any) => {
  if (hide) {
    return null
  }
  return (
    <Box {...styles.container} paddingHorizontal={24} backgroundColor="WHITE" pv={16}>
      <Box flexDirection="row">{getView(data.details)}</Box>
      <Box paddingVertical={8} marginRight={16}>
        <TextInputWithCb label={'Description'} value={data.description ?? ''} showCheckbox={false} />
      </Box>
      <Box flexDirection="row" flexWrap="wrap">
        {getView(data.extras)}
      </Box>
    </Box>
  )
}

const shadow = {
  shadowColor: '#000',
  shadowOffset: {
    width: 1,
    height: 1,
  },
  shadowOpacity: 0.1,
  shadowRadius: 4,
  zIndex: 10,
}

const styles = {
  container: {
    ...shadow,
    borderWidth: 1,
    borderTopWidth: 0,
    borderBottomRightRadius: 4,
    borderBottomLeftRadius: 4,
    borderColor: '#e3e6f0' as ColorOptions,
  } as BoxProps,
}
